import React from 'react'

export const IconPostcard = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
      <path d="M19.312 19c.932 0 1.688-.784 1.688-1.75V6.75C21 5.784 20.244 5 19.312 5H4.687C3.756 5 3 5.784 3 6.75v10.5c0 .966.756 1.75 1.687 1.75h14.625zM12 14.333c-.816.015-1.99-1.163-2.58-1.651-3.425-2.818-4.525-3.748-5.295-4.423V6.75c0-.32.253-.583.562-.583h14.625c.31 0 .563.262.563.583v1.51c-.77.674-1.87 1.604-5.295 4.422-.594.488-1.764 1.666-2.58 1.651zm7.312 3.5H4.687a.574.574 0 01-.562-.583V9.776c.802.682 2.067 1.735 4.595 3.817.72.598 1.993 1.914 3.28 1.907 1.28.01 2.542-1.294 3.28-1.907a422.338 422.338 0 004.595-3.817v7.474c0 .32-.253.583-.563.583z" />
    </svg>
  )
}
